import { NgModule } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { MsgSuccessLayoutComponent } from './success/msg-success-layout.component';
import { MsgErrorLayoutComponent } from './error/msg-error-layout.component';
import { MsgInfoLayoutComponent } from './info/msg-info-layout.component';

@NgModule({
    entryComponents: [
        MsgSuccessLayoutComponent,
        MsgErrorLayoutComponent,
        MsgInfoLayoutComponent,
    ],
    declarations: [
        MsgSuccessLayoutComponent,
        MsgErrorLayoutComponent,
        MsgInfoLayoutComponent,
    ],
    imports: [
        MatIconModule,
        MatSnackBarModule,
        MatDialogModule,
        MatButtonModule
    ]
})

export class MsgModule {
}